@if (isTransactionSuccess && !hideSuccessPage) {
    <div class="deposit-success-wrapper" [ngClass]="{ 'border-0': configParams?.isBrazilBankRegEnabled }">
        <input type="hidden" name="adaPullchatUrl" id="adaPullchatUrl" />
        @if (response?.adaDepositStatus?.depositBlocked) {
            <div class="mb-3">
                <show-message [type]="messageType.INFO">
                    <div info>
                        @if (isCountryUK) {
                            <p class="line-spacing">
                                {{
                                    'PARTY.CASHIER.web.deposit.ada.intervention.uk.msg'
                                        | translate
                                            : {
                                                  time: response?.adaDepositStatus?.expiryTime,
                                                  date: response?.adaDepositStatus?.expiryDate,
                                              }
                                }}
                            </p>
                            <p
                                class="line-spacing"
                                [vnDynamicHtml]="
                                    'PARTY.CASHIER.web.deposit.ada.intervention.gambling.msg' | translate: { gamblingControl: gamblingControlURL }
                                "></p>
                        }
                        @if (!isCountryUK) {
                            <p class="line-spacing">
                                {{
                                    'PARTY.CASHIER.web.ada.intervention.msg1'
                                        | translate
                                            : {
                                                  time: response?.adaDepositStatus?.expiryTime,
                                                  date: response?.adaDepositStatus?.expiryDate,
                                              }
                                }}
                            </p>
                        }
                        @if (isCountryUK) {
                            <p
                                class="line-spacing"
                                class="float-none"
                                [vnDynamicHtml]="
                                    'PARTY.CASHIER.web.deposit.ada.intervention.uk.msg4'
                                        | translate
                                            : {
                                                  cpccContactLink: response?.adaDepositStatus?.cpccContactLink,
                                              }
                                "></p>
                        }
                        @if (!isCountryUK) {
                            <p
                                class="line-spacing float-none"
                                [vnDynamicHtml]="
                                    'PARTY.CASHIER.web.ada.intervention.msg2'
                                        | translate
                                            : {
                                                  cpccContactLink: response?.adaDepositStatus?.cpccContactLink,
                                              }
                                "></p>
                        }
                        <b>
                            @if (showChatNotAvailable) {
                                <div>
                                    @if (!isCountryUK) {
                                        <a href="javascript:void(0)" class="float-right mt-2">
                                            {{ 'PARTY.CASHIER.web.deposit.chat.here.text' | translate }}
                                        </a>
                                    } @else {
                                        <a href="javascript:void(0)" class="float-right mt-2">
                                            {{ 'PARTY.CASHIER.web.deposit.chat.here.en.text' | translate }}
                                        </a>
                                    }
                                    <div class="zendesk-live-block">{{ 'PARTY.CASHIER.web.deposit.chat.zendesk.text' | translate }}</div>
                                </div>
                            }
                            @if ((pullchatEnabled || zendeskEnabled) && !showChatNotAvailable && !hideChat) {
                                <div>
                                    @if (!isCountryUK) {
                                        <a (click)="triggerChat()" class="float-right mt-2">
                                            {{ 'PARTY.CASHIER.web.deposit.chat.here.text' | translate }}
                                        </a>
                                    } @else {
                                        <a (click)="triggerChat()" class="float-right mt-2">
                                            {{ 'PARTY.CASHIER.web.deposit.chat.here.en.text' | translate }}
                                        </a>
                                    }
                                </div>
                            }
                        </b>
                    </div>
                </show-message>
            </div>
        }
        @if (!response?.adaDepositStatus?.depositBlocked) {
            <div class="mb-3">
                @if (
                    response?.rgPercentage ||
                    response?.hardStopLTMPercentage ||
                    response?.hardStopMonthlyPercentage ||
                    response?.successMessageInfo?.showAffNetLossMsg === 'Y'
                ) {
                    <show-message [type]="messageType.SUCCESS">
                        <div success>
                            @if (response?.rgPercentage != null) {
                                @if (response?.responsibleGamingHelpUrl?.url) {
                                    <div>
                                        <span>{{ 'PARTY.CASHIER.web.deposit.qd.success.rgthreshold.limit.reached' | translate }}</span>
                                        @if (response?.responsibleGamingHelpUrl.url) {
                                            <span>
                                                <a href="{{ response?.responsibleGamingHelpUrl.url }}" target="_blank">
                                                    {{ 'PARTY.CASHIER.web.deposit.qd.success.rgthreshold.responsible.help' | translate }}
                                                </a>
                                            </span>
                                        }
                                    </div>
                                }
                                @if (!response?.responsibleGamingHelpUrl || !response?.responsibleGamingHelpUrl.url) {
                                    <div>
                                        <span>
                                            {{
                                                'PARTY.CASHIER.web.deposit.qd.success.rgthreshold.message'
                                                    | translate
                                                        : {
                                                              rgPercentage: response?.rgPercentage,
                                                          }
                                            }}
                                        </span>

                                        <span>
                                            @switch (response?.rgType) {
                                                @case ('daily') {
                                                    <span>{{ 'PARTY.CASHIER.web.deposit.qd.success.rgthreshold.daily' | translate }}</span>
                                                }
                                                @case ('weekly') {
                                                    <span>{{ 'PARTY.CASHIER.web.deposit.qd.success.rgthreshold.weekly' | translate }}</span>
                                                }
                                                @case ('monthly') {
                                                    <span>{{ 'PARTY.CASHIER.web.deposit.qd.success.rgthreshold.monthly' | translate }}</span>
                                                }
                                                @default {
                                                    <span>{{ 'PARTY.CASHIER.web.deposit.qd.success.rgthreshold.depositlimit' | translate }}</span>
                                                }
                                            }
                                        </span>

                                        @if (response?.urlInfo.url != null && response?.urlInfo?.url) {
                                            <span>
                                                <a href="{{ response?.urlInfo?.url }}" target="_blank">
                                                    {{ 'PARTY.CASHIER.web.deposit.qd.success.rgthreshold.click.here' | translate }}
                                                </a>
                                                {{ 'PARTY.CASHIER.web.deposit.qd.success.rgthreshold.message1' | translate }}
                                            </span>
                                        }
                                    </div>
                                }
                            }
                            @if (response?.hardStopLTMPercentage != null && response?.successMessageInfo?.showAffNetLossMsg === 'N') {
                                <div id="hardStopchatUrl" class="mr-1">
                                    @if (response?.under21age) {
                                        @if (isHundredPercentageHardStopReached) {
                                            <div class="text-bold line-spacing">
                                                {{
                                                    'PARTY.CASHIER.web.yearly.hardstop.limit.success3'
                                                        | translate
                                                            : {
                                                                  limit: response?.hardStopLimit | vnCurrency: currencyGBP,
                                                              }
                                                }}
                                            </div>
                                        } @else {
                                            <div
                                                class="text-bold line-spacing"
                                                [vnDynamicHtml]="
                                                    'PARTY.CASHIER.web.yearly.hardstop.limit.success'
                                                        | translate
                                                            : {
                                                                  limit: response?.hardStopLimit | vnCurrency: currencyGBP,
                                                              }
                                                "></div>
                                        }
                                        <p class="line-spacing">
                                            {{ 'PARTY.CASHIER.web.deposit.prorgdeplimits.exceeded.bea' | translate }}
                                            <a href="mailto:{{ response?.playerProtectionEmail }}" target="_top">
                                                {{ response?.playerProtectionEmail }}.</a
                                            >
                                        </p>
                                        <p class="line-spacing">
                                            {{ 'PARTY.CASHIER.web.svoc.harstop.deposit.more.info' | translate }}
                                            <a href="{{ response?.hardstopInfoLink }}" target="_blank"> {{ response?.hardstopInfoLink }}. </a>
                                        </p>
                                    } @else {
                                        <div
                                            class="text-bold line-spacing"
                                            [vnDynamicHtml]="'PARTY.CASHIER.web.yearly.affordibility.limit.header2' | translate"></div>
                                        <p
                                            class="line-space"
                                            [vnDynamicHtml]="
                                                'PARTY.CASHIER.web.svoc.harstop.limit.success.uk.msg1'
                                                    | translate
                                                        : {
                                                              percentage: response?.hardStopLTMPercentage,
                                                              netDepLimit: response?.hardStopLimit | vnCurrency: currencyGBP,
                                                              url: response?.hardstopInfoLink,
                                                          }
                                            "></p>
                                        <p class="line-space">{{ 'PARTY.CASHIER.web.svoc.harstop.limit.success.uk.msg2' | translate }}</p>
                                    }
                                </div>
                            }
                            @if (response?.hardStopMonthlyPercentage != null && response?.successMessageInfo?.showAffNetLossMsg === 'N') {
                                <div id="hardStopchatUrl" class="mr-1">
                                    @if (response?.f30DHardstopLimit) {
                                        <p
                                            class="line-spacing mt-1 text-bold"
                                            (click)="monthlyLimit($event)"
                                            [vnDynamicHtml]="
                                                'PARTY.CASHIER.web.monthly.hardstop.limit.success4'
                                                    | translate
                                                        : {
                                                              limit: response?.hardStopLimit | vnCurrency: currencyGBP,
                                                              url: response?.hardstopInfoLink,
                                                          }
                                            "></p>
                                        <p
                                            class="line-spacing mt-1"
                                            [vnDynamicHtml]="
                                                'PARTY.CASHIER.web.hardstop.limit.to.be.exceeded.msg6'
                                                    | translate
                                                        : {
                                                              limit: response?.hardStopLimit | vnCurrency: currencyGBP,
                                                              percent: response?.hardStopMonthlyPercentage,
                                                              url: response?.contactUs,
                                                          }
                                            "></p>
                                    } @else {
                                        <p
                                            class="line-spacing mt-1 text-bold"
                                            (click)="monthlyLimit($event)"
                                            [vnDynamicHtml]="
                                                'PARTY.CASHIER.web.monthly.hardstop.limit.success'
                                                    | translate
                                                        : {
                                                              limit: response?.hardStopLimit | vnCurrency: currencyGBP,
                                                              url: response?.hardstopInfoLink,
                                                          }
                                            "></p>
                                        <p
                                            class="line-spacing mt-1"
                                            [vnDynamicHtml]="
                                                'PARTY.CASHIER.web.hardstop.limit.to.be.exceeded.msg5'
                                                    | translate
                                                        : {
                                                              limit: response?.hardStopLimit | vnCurrency: currencyGBP,
                                                              percent: response?.hardStopMonthlyPercentage,
                                                              url: response?.contactUs,
                                                          }
                                            "></p>
                                    }
                                </div>
                            }
                            @if (response?.successMessageInfo?.showAffNetLossMsg === 'Y') {
                                <div class="mr-1">
                                    <p class="line-spacing text-bold">
                                        {{ 'PARTY.CASHIER.web.deposit.aff.high.velocity.msg1' | translate }}
                                    </p>
                                    <p class="line-spacing mt-1">
                                        {{ 'PARTY.CASHIER.web.deposit.aff.high.velocity.msg2' | translate }}
                                    </p>
                                    <p
                                        class="line-spacing mt-1"
                                        (click)="lossLimitDepositCapClick($event)"
                                        [vnDynamicHtml]="
                                            'PARTY.CASHIER.web.deposit.aff.high.velocity.msg3'
                                                | translate: { url: response?.successMessageInfo?.increaseLimitsUrl }
                                        "></p>
                                </div>
                            }
                        </div>
                    </show-message>
                }
            </div>
        }
        @if (showChatNotAvailable && !response?.hardStopMonthlyPercentage) {
            <div>
                <div class="live-help zendesk-live-block form-control">
                    <a href="javascript:void(0)">
                        <svg
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            viewBox="-463 265 32 32"
                            fill="#000"
                            style="enable-background: new -463 265 32 32; height: 24px; width: 24px; padding: 0 5px 2px 0; float: left"
                            xml:space="preserve">
                            <path
                                d="M-434.9,265H-459c-2.2,0-4,1.8-4,4v15.9c0,2.2,1.8,4,4,4h2.3v6.9c0,0.5,0.3,1,0.8,1.2c0.2,0.1,0.4,0.1,0.6,0.1
					c0.3,0,0.6-0.1,0.9-0.3l9.2-7.9h10.3c2.2,0,4-1.8,4-4V269C-430.9,266.8-432.7,265-434.9,265z M-455.4,278.9c-1.3,0-2.4-1.1-2.4-2.4
					c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4C-453,277.8-454.1,278.9-455.4,278.9z M-447,278.9c-1.3,0-2.4-1.1-2.4-2.4
					c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4C-444.6,277.8-445.7,278.9-447,278.9z M-438.6,278.9c-1.3,0-2.4-1.1-2.4-2.4
					c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4C-436.2,277.8-437.3,278.9-438.6,278.9z"></path>
                        </svg>
                        {{ 'PARTY.CASHIER.web.deposit.chat.here.text' | translate }}
                    </a>
                    <div class="zendesk-live-block">{{ 'PARTY.CASHIER.web.deposit.chat.zendesk.text' | translate }}</div>
                </div>
            </div>
        }
        @if (
            (pullchatEnabled || zendeskEnabled) &&
            response?.hardStopLTMPercentage != null &&
            !(response?.hardStopLTMPercentage <= 100) &&
            !response?.under21age &&
            !showChatNotAvailable &&
            !hideChat
        ) {
            <div>
                <button (click)="triggerChat()" type="button" class="live-help form-control">
                    <svg
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="-463 265 32 32"
                        fill="#000"
                        style="enable-background: new -463 265 32 32; height: 24px; width: 24px; padding: 0 5px 2px 0; float: left"
                        xml:space="preserve">
                        <path
                            d="M-434.9,265H-459c-2.2,0-4,1.8-4,4v15.9c0,2.2,1.8,4,4,4h2.3v6.9c0,0.5,0.3,1,0.8,1.2c0.2,0.1,0.4,0.1,0.6,0.1
					c0.3,0,0.6-0.1,0.9-0.3l9.2-7.9h10.3c2.2,0,4-1.8,4-4V269C-430.9,266.8-432.7,265-434.9,265z M-455.4,278.9c-1.3,0-2.4-1.1-2.4-2.4
					c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4C-453,277.8-454.1,278.9-455.4,278.9z M-447,278.9c-1.3,0-2.4-1.1-2.4-2.4
					c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4C-444.6,277.8-445.7,278.9-447,278.9z M-438.6,278.9c-1.3,0-2.4-1.1-2.4-2.4
					c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4C-436.2,277.8-437.3,278.9-438.6,278.9z"></path>
                    </svg>
                    {{ 'PARTY.CASHIER.web.deposit.chat.here.text' | translate }}
                </button>
            </div>
        }
        <div class="deposit-success-box text-center mt-1">
            <div [ngClass]="userGroup != 'usa' ? 'nonus_deposit_success_logo' : 'us_deposit_success_logo'"></div>
            @if (configParams?.pixBrInfo?.isSeamless) {
                <div class="text-bold txt-xl-v2 deposit-success-txt my-3">
                    {{ 'PARTY.CASHIER.web.deposit.success.message1.pixSeamlessHeader' | translate }}
                </div>
            } @else {
                <div class="text-bold txt-xl-v2" [ngClass]="userGroup != 'usa' ? 'deposit-success-txt my-3' : 'mb-3'">
                    {{ 'PARTY.CASHIER.web.deposit.success.message.header' | translate }}
                </div>
            }
        </div>
        <div class="text-center mx-auto" [ngClass]="configParams?.colombia_deposit_tax_enabled == 'Y' ? 'mb-2' : 'mb-5'">
            <div class="txt-md-v2">
                @if (configParams?.pixBrInfo?.isSeamless) {
                    <div
                        class="mb-3"
                        [vnDynamicHtml]="
                            'PARTY.CASHIER.web.deposit.success.pixbrSeamlessMessage.msg'
                                | translate
                                    : { amount: response?.amountInAccountCurrency | vnCurrency: response?.amount?.currencyCode, label: labelName }
                        "></div>
                } @else {
                    <span
                        [vnDynamicHtml]="
                            'PARTY.CASHIER.web.deposit.success.amount.added.account'
                                | translate: { amount: response?.amountInAccountCurrency | vnCurrency: response?.amount?.currencyCode }
                        ">
                    </span>
                }
            </div>
            <div class="txt-md-v2">
                <span>{{ 'PARTY.CASHIER.web.deposit.success.total.balance.text' | translate }} </span>
                <span class="text-bold">
                    @if (response?.paymentMethod == 'PAYPAL' && paypalOnlyForSports) {
                        {{ response?.paypalBalance | vnCurrency: response?.accountCurrency }}
                    } @else {
                        {{ response?.successMessageInfo?.main_balance | vnCurrency: response?.successMessageInfo?.account_currency }}
                    }
                </span>
            </div>
            @if (configParams?.colombia_deposit_tax_enabled == 'Y') {
                <div class="cashier-message-wrapper d-flex justify-content-center taxinfo">
                    <div class="cashier-message-container">
                        <div class="message-box message-box-graybg no-border">
                            <div class="message-inner-box">
                                <p class="message-text-left">{{ 'PARTY.CASHIER.web.deposit.vatTaxInfo.totalDeposit' | translate }}</p>
                                <p class="message-text-right tax-text text-bold">
                                    {{ response?.amountInAccountCurrency.toFixed(2) }} {{ response?.amount?.currencyCode | vnCurrencySymbol }}
                                </p>
                            </div>
                            <div class="message-inner-box">
                                <p class="message-text-left">{{ 'PARTY.CASHIER.web.deposit.vatTaxInfo.vatDeduction' | translate }}</p>
                                <p class="message-text-right tax-text text-bold">
                                    -{{ depositService.vatDeductionAmount() }} {{ response?.amount?.currencyCode | vnCurrencySymbol }}
                                </p>
                            </div>
                            <div class="message-inner-box">
                                <p class="message-text-left">{{ 'PARTY.CASHIER.web.deposit.vatTaxInfo.bonus' | translate }}</p>
                                <p class="message-text-right tax-text text-bold success-txt">
                                    {{ depositService.vatDeductionAmount() }} {{ response?.amount?.currencyCode | vnCurrencySymbol }}
                                </p>
                            </div>
                            <div class="message-inner-box">
                                <p class="message-text-left">{{ 'PARTY.CASHIER.web.deposit.vatTaxInfo.netDeposit' | translate }}</p>
                                <p class="message-text-right tax-text text-bold">
                                    {{ response?.amountInAccountCurrency.toFixed(2) }} {{ response?.amount?.currencyCode | vnCurrencySymbol }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
        @if (showDoneCTA) {
            <div class="w-100 mx-auto" (click)="startTimer()">
                <button class="btn btn-primary w-100">
                    @if (userGroup == 'usa') {
                        {{ 'PARTY.CASHIER.web.betnow.button' | translate }}
                    } @else {
                        {{ 'PARTY.CASHIER.common.done' | translate }}
                    }
                </button>
            </div>
        }
    </div>
}
